




































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class HambatanBudaya extends Vue {
  @Prop() setHambatanBudaya: string;
  // hambatanBudaya = "";
  label = "";
  // validasi = [(v) => this.cek(v)];
  // get hambatanBudaya() {
  //   return this.setHambatanBudaya;
  // }
  // set hambatanBudaya(value) {
  //   this.$emit("hambatanBudaya", value);
  // }
  // @Watch("hambatanBudaya")
  // changed(v) {
  //   if (!v) {
  //     this.label = "";
  //   } else {
  //     this.label = "Hambatan Budaya";
  //   }
  //   this.$emit("hambatanBudaya", v);
  // }

  showHambatan = false;
  radioHambatan = "0";
  mounted() {
    if (!this.setHambatanBudaya) {
      this.label = "";
      this.radioHambatan = "0";
    } else {
      this.label = "Hambatan Budaya";
      this.radioHambatan = "1";
    }
  }
  @Watch("radioHambatan")
  change(v) {
    if (this.radioHambatan == "0") {
      this.showHambatan = false;
      this.setHambatanBudaya = null;
    } else {
      this.showHambatan = true;
    }
  }
  @Watch("setHambatanBudaya")
  changedSet(v) {
    if (!v) {
      this.label = "";
      this.radioHambatan = "0";
    } else {
      this.label = "Hambatan Budaya";
      this.radioHambatan = "1";
    }
    this.$emit("hambatanBudaya", v);
    // this.hambatanBudaya = v;
  }
}
